import { Group, Menu, rem, Text, UnstyledButton } from "@mantine/core"
import { IconChevronDown } from "@tabler/icons-react"
import { useState } from "react"
import classes from "./LanguagePicker.module.css"

type Language = {
  label: string
  code: string
  image: string
}

type LanguagePickerProps = {
  currentLanguage: string
  onChange?: (language: Language) => void
}

const languages: Language[] = [
  { label: "English", code: "en", image: "https://flagcdn.com/96x72/us.webp" },
  { label: "Deutsch", code: "de", image: "https://flagcdn.com/96x72/de.webp" },
  { label: "Italiano", code: "it", image: "https://flagcdn.com/96x72/it.webp" },
  { label: "Français", code: "fr", image: "https://flagcdn.com/96x72/fr.webp" },
  { label: "Español", code: "es", image: "https://flagcdn.com/96x72/es.webp" }
]

const componentWidth = rem(100)

export function LanguagePicker({ currentLanguage: selected, onChange: onLanguageSelect }: LanguagePickerProps) {
  const [opened, setOpened] = useState<boolean>(false)
  const selectedLanguage = languages.find((lang) => lang.code === selected) || languages[0]
  const handleSelect = (item: Language) => {
    if (onLanguageSelect) {
      onLanguageSelect(item)
    }
  }

  const items = languages.map((item) => (
    <Menu.Item onClick={() => handleSelect(item)} key={item.label}>
      {item.label}
    </Menu.Item>
  ))

  return (
    <Menu
      onOpen={() => setOpened(true)}
      onClose={() => setOpened(false)}
      radius="md"
      width={componentWidth}
      withinPortal
    >
      <Menu.Target>
        <UnstyledButton className={classes.control} data-expanded={opened || undefined} w={componentWidth} p={rem(8)}>
          <Group justify={"space-evenly"} w={componentWidth}>
            <Text className={classes.label} opacity={0.85}>
              {selectedLanguage.label}
            </Text>
            <IconChevronDown size={14} className={classes.icon} />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>{items}</Menu.Dropdown>
    </Menu>
  )
}
